import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

import offer from 'src/types/offer';
import styles from 'src/components/Offers.scss';
import Offer from 'src/components/Offer';


// eslint-disable-next-line max-lines-per-function
const Offers = function ({ offers, remove, toggleFavourite }) {
  const jobOffersURL = useSelector(
    ({ configReducer }) => configReducer.jobOffersURL
  );

  // eslint-disable-next-line max-len
  const getJobLink = ({ offerAbsoluteUri, offerURLName, sug }) => (offerAbsoluteUri ? `${offerAbsoluteUri}${sug ? `?sug=${sug}` : ''}` : `${[jobOffersURL, offerURLName].join('/')}${sug ? `?sug=${sug}` : ''}`);

  return (
    <TransitionGroup component={ null }>
      {offers.map(
        ({
          offerId,
          jobTitle,
          regionName,
          countryName,
          workplace,
          companyLogoUri,
          offerURLName,
          isFavourite,
          companyName,
          sug,
          isSuperOffer,
          isOneClickApply,
          offerAbsoluteUri
        }) => (
          <CSSTransition
            key={ offerId }
            classNames={ {
              exitActive: `${styles['offer--exit-active']}`,
              exited: styles['offer--exited']
            } }
            timeout={ 300 }
          >
            <Offer
              company={ companyName }
              id={ offerId }
              isFavourite={ isFavourite }
              isOneClickApply={ isOneClickApply }
              isSuperOffer={ isSuperOffer }
              jobLink={ getJobLink({ offerAbsoluteUri, offerURLName, sug }) }
              jobTitle={ jobTitle }
              location={ workplace || regionName || countryName }
              logo={ companyLogoUri }
              remove={ remove }
              toggleFavourite={ toggleFavourite }
            />
          </CSSTransition>
        )
      )}
    </TransitionGroup>
  );
};

Offers.propTypes = {
  offers: PropTypes.arrayOf(offer).isRequired,
  remove: PropTypes.func,
  toggleFavourite: PropTypes.func.isRequired
};

Offers.defaultProps = {
  remove: null
};

export default Offers;
